import React, { ReactNode } from 'react'
import * as Sentry from 'sentry-expo'
import { StatusBar } from 'react-native'
import { Provider } from 'react-redux'

import 'react-native-gesture-handler'
import { store } from './src/store/configureStore'

import useCachedResources from './src/hooks/useCachedResources'
import AppNavigator from './src/navigators/AppNavigator'
import { getVersion } from './src/lib/utils'

Sentry.init({
  dsn:
    'https://ff126a2dd8db430d89a683e09c27f321@o578383.ingest.sentry.io/5734581',
  enableInExpoDevelopment: true,
  debug: !!__DEV__,
  release: getVersion(),
})

// const initialState = {
//   user: {
//     patientGroup: null,
//     uid: null,
//   },
// }

// react-redux-firebase config
// const rrfConfig = {
//   userProfile: 'users',
//   // useFirestoreForProfile: true // Firestore for Profile instead of Realtime DB
// }

const App: () => ReactNode = () => {
  const isLoadingComplete = useCachedResources(store)

  if (!isLoadingComplete) {
    return null
  }

  return (
    <Provider store={store}>
      <StatusBar barStyle="dark-content" />
      <AppNavigator />
    </Provider>
  )
}

export default App
